<template>
  <v-dialog v-model="dialog" persistent :overlay="false" scrollable
  :fullscreen="$vuetify.breakpoint.smAndDown || $vuetify.breakpoint.mdAndDown || $vuetify.breakpoint.lgOnly"
  transition="dialog-bottom-transition">
    <v-card>
      <loading :active.sync="loading" background-color="#C5CAE9" color="#1A237E" :is-full-page="false"/>
      <v-toolbar color="blue darken-3" dark flat>
        <v-toolbar-title>
          <span class="font-awesome display-1 ml-5">{{ canEdit ? title : 'Información del producto' }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('Close')" icon>
          <v-icon size="30">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step editable step="1">Información del producto</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">Responda la Siguientes Preguntas</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" style="overflow: auto">
            <v-layout column style="height: 65vh">
              <v-flex style="overflow: auto">
                <v-container>
                  <v-row>
                    <!-- Region 1 -->
                    <v-col cols="12" sm="12" md="3" lg="2" xl="2">
                      <v-text-field v-model="codeSat" label="Código Producto" class="title"
                      placeholder="Buscar código SAT" :readonly="!canEdit" autocomplete="off">
                        <template v-slot:prepend-inner v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="blue darken-3">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="OpenSearch = true" v-on="on" icon small color="blue darken-3">
                                <v-icon color="blue darken-3">mdi-open-in-new</v-icon>
                              </v-btn>
                            </template>
                            <span>Buscar codigo</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="8" lg="5" xl="5">
                      <v-text-field v-model="NombreP" maxlength="150" counter @input="$v.NombreP.$touch()"
                      @blur="$v.NombreP.$touch()" :error-messages="NombrePErrors" prepend-inner-icon="mdi-package-variant-closed"
                      label="Nombre de Producto" :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="5" xl="5">
                      <v-text-field v-model="NombreF" @input="$v.NombreF.$touch()" @blur="$v.NombreF.$touch()"
                      :error-messages="NombreFErrors" maxlength="150" counter prepend-inner-icon="mdi-file-pdf"
                      label="Nombre en factura" :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="4" xl="3">
                      <v-text-field v-model="NombreR" @input="$v.NombreR.$touch()" @blur="$v.NombreR.$touch()"
                      :error-messages="NombreRErrors" maxlength="50" counter prepend-inner-icon="mdi-ticket"
                      label="Nombre en ticket" :readonly="!canEdit" autocomplete="off">
                        <template v-slot:append-inner>
                          <v-tooltip bottom color="indigo darken-3" max-width="200">
                            <template v-slot:activator="{ on }">
                              <v-icon color="indigo darken-3" v-on="on">
                                mdi-help-circle
                                </v-icon>
                            </template>
                            <span>Nombre Impreso en ticket (Punto de Venta)</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- Region 2 -->
                    <v-col cols="12" sm="12" md="4" lg="3" xl="2">
                      <v-text-field label="Código Producto" counter prepend-inner-icon="mdi-clipboard-text"
                      v-model="codigoP" @input="$v.codigoP.$touch()" @blur="validateCode()" :error-messages="codigoPErrors"
                      maxlength="20" :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="3" xl="2">
                      <v-text-field name="codigoB" color="indigo accent-4" label="Código Barras"
                      counter prepend-inner-icon="mdi-barcode" v-model="codigoB" maxlength="20"
                      :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="5" lg="4" xl="3">
                      <v-autocomplete v-model="Category" @input="$v.Category.$touch()" @blur="$v.Category.$touch()"
                      :error-messages="CategoryErrors" item-text="name" item-value="id" label="Categoria" :items="Categoria" color="indigo accent-4"
                      :readonly="!canEdit" autocomplete="off">
                        <template v-slot:append-outer v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="indigo darken-2">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="Add(1)" v-on="on" icon small color="indigo darken-3">
                                <v-icon size="25">mdi-pencil-plus-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Crear nueva Categoría</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="4" xl="3">
                      <v-autocomplete v-model="SubCategoria" item-text="name" item-value="id" label="Subcategoria"
                      :items="SubCategorias" color="indigo accent-4" :readonly="!canEdit" autocomplete="off">
                        <!-- <template v-slot:append-outer v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="indigo darken-2">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="Add(4)" v-on="on" icon small color="indigo darken-3">
                                <v-icon size="25">mdi-pencil-plus-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Crear nueva Subcategoría</span>
                          </v-tooltip>
                        </template> -->
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="3" xl="2">
                      <v-autocomplete v-model="Unidad" @input="$v.Unidad.$touch()" @blur="$v.Unidad.$touch()"
                      :error-messages="UnidadErrors" item-text="name" item-value="id" label="Unidades" :items="Unidades"
                      color="indigo accent-4" :readonly="!canEdit" autocomplete="off">
                        <template v-slot:append-outer v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="indigo darken-3">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="Add(2)" v-on="on" icon small color="indigo darken-3">
                                <v-icon size="25">mdi-pencil-plus-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Crear nueva Unidad de Medida</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col class="" cols="12" sm="12" md="6" lg="6" xl="6">
                      <v-combobox v-model="list_tags" :items="Tags" prepend-inner-icon="mdi-tag-multiple"
                      dense deletable-chips chips small-chips multiple item-text="name" item-value="id"
                      return-object :readonly="!canEdit" autocomplete="off">
                        <template v-slot:selection="{ attrs, item, select, selected }">
                          <v-chip v-bind="attrs" :input-value="item" close @click="select"
                          :disabled="!canEdit" small color="indigo darken-2" text-color="white" @click:close="remove(item)">
                            <v-icon left>mdi-label</v-icon>
                            <span>{{ item.name }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:append-outer v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="blue darken-3">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="addTag = true" v-on="on" icon small color="blue darken-3">
                                <v-icon size="25">mdi-tag-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>Agregar nueva etiqueta</span>
                          </v-tooltip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="6" xl="6">
                      <v-autocomplete v-model="Proveedor" item-text="name" item-value="id" label="Proveedor"
                      :items="Proveedores" color="indigo accent-4" :readonly="!canEdit" autocomplete="off">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="5" lg="2" xl="2">
                      <v-text-field ref="Precio" v-model="Precio" name="Precio"
                      v-money="money" prepend-inner-icon="mdi-currency-usd" id="Precio"
                      label="Precio final" color="indigo accent-4" @blur="$v.Precio.$touch()" @input="$v.Precio.$touch()"
                      :error-messages="PrecioErrors" :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="2" xl="2">
                      <v-text-field ref="Costo" v-model="Costo" name="Costo"
                      v-money="moneyCosto" prepend-inner-icon="mdi-currency-usd" id="Costo"
                      label="Costo" color="indigo accent-4"
                      :readonly="!canEdit" autocomplete="off"/>
                    </v-col>
                    <v-col cols="12" sm="12" md="5" lg="4" xl="3">
                      <v-autocomplete v-model="ImpMonto" @blur="$v.ImpMonto.$touch()" @input="$v.ImpMonto.$touch()"
                      :error-messages="ImpMontoErrors" multiple item-text="name" label="Impuesto" return-object :items="Impuestos"
                      color="indigo accent-4" :readonly="!canEdit" autocomplete="off">
                       <template v-slot:append-outer v-if="canEdit">
                          <v-tooltip max-width="200" bottom color="indigo darken-3">
                            <template v-slot:activator="{ on }">
                              <v-btn @click="Add(3)" v-on="on" icon small color="indigo darken-3">
                                <v-icon size="25" >mdi-pencil-plus-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Crear nuevo Impuesto</span>
                          </v-tooltip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="1" sm="12" md="4" lg="3" xl="3">
                      <v-layout column style="height: 30vh">
                        <v-flex style="overflow: auto">
                          <v-simple-table :dense="true">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left title">Impuesto</th>
                                  <th class="text-left title">Monto</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, id) in ImpMonto" :key="id">
                                  <td class="title">{{ item.alias }}</td>
                                  <td class="title">
                                    $ {{ setMonto(item.percent, item.satCode) }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="title text-left">Precio venta</td>
                                  <td class="title">
                                    {{SetCoin(parseFloat(PrecioFormat /(1 + Total_Imp)))}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="title text-left">Precio costo</td>
                                  <td class="title">
                                    {{SetCoin(parseFloat(CostoFormat /(1 + Total_Imp)))}}
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-container>
              </v-flex>
            </v-layout>
          </v-stepper-content>
          <v-stepper-content editable step="2">
            <v-layout column style="height: 65vh">
              <v-flex style="overflow: auto">
                <v-container>
                  <v-row>
                    <v-col cols="6" class="mt-n3">
                      <v-row>
                        <v-col cols="auto">
                          <span class="text-h4">
                            ¿El producto es Inventariable?
                          </span>
                        </v-col>
                        <v-col cols="1">
                          <v-tooltip bottom color="indigo darken-3" max-width="200">
                            <template v-slot:activator="{ on }">
                              <v-icon color="indigo darken-3" v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <div class="white--text text-justify">
                              Un producto
                              <b>Inventariable</b> es aquel, que necesita llevar
                              un control de entrada y salida.
                            </div>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="5">
                          <v-switch class="mt-n1" color="indigo accent-4" inset :label="Swtinvt == true ? 'Si' : 'No'" v-model="Swtinvt" :disabled="!canEdit"/>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6" class="mt-n3">
                      <v-row>
                        <v-col cols="auto">
                          <span class="mt-n1">
                            ¿ El producto requiere pasar por producción ? &nbsp;
                            <v-tooltip bottom color="indigo darken-3" max-width="300">
                              <template v-slot:activator="{ on }">
                                <v-icon size="20" color="indigo darken-3" v-on="on">mdi-help-circle</v-icon>
                              </template>
                              <div class="white--text text-justify">
                                Un producto
                                <b>que requiere producción</b>, es aquel, que se
                                compone de un proceso de preparacion y/o
                                fabricacion
                              </div>
                            </v-tooltip>
                          </span>
                        </v-col>
                        <v-col cols="auto">
                          <v-switch class="mt-n1" @change="SetVal(1)" :readonly="readonlyProd" color="green accent-4"
                          inset :label="Swtprod == true ? 'Si' : 'No'" :disabled="!canEdit" v-model="Swtprod"/>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="6" class="mt-n3">
                      <v-row>
                        <v-col cols="auto">
                          <span class="mt-n1">
                            ¿El producto se compone de insumos? &nbsp;
                            <v-tooltip bottom color="indigo darken-3" max-width="300">
                              <template v-slot:activator="{ on }">
                                <v-icon size="20" color="indigo darken-3" v-on="on">mdi-help-circle</v-icon>
                              </template>
                              <div class="white--text text-justify">
                                Un producto
                                <b>se compone de insumos</b>
                                , si este necesita de uno o varios otros
                                productos (insumos) para llegar a su estado
                                final. Vease como una receta de preparacion.
                              </div>
                            </v-tooltip>
                          </span>
                        </v-col>
                        <v-col cols="auto">
                          <v-switch
                            class="mt-n1"
                            :readonly="readOnlyinsu"
                            color="yellow accent-4"
                            inset
                            :label="Swtinsu == true ? 'Si' : 'No'"
                            :disabled="!canEdit"
                            v-model="Swtinsu"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="auto" class="mt-n3">
                      <v-row>
                        <v-col cols="auto">
                          <span class="mt-n1">
                            ¿El producto es complemento de otro producto? &nbsp;
                            <v-tooltip bottom color="indigo darken-3" max-width="200">
                              <template v-slot:activator="{ on }">
                                <v-icon size="20" color="indigo darken-3" v-on="on">mdi-help-circle</v-icon>
                              </template>
                              <div class="white--text text-justify">
                                Un producto
                                <b>es un complemento</b>, si este forma parte de
                                la receta de otro o varios productos mas.
                              </div>
                            </v-tooltip>
                          </span>
                        </v-col>
                        <v-col cols="auto">
                          <v-switch
                            class="mt-n1"
                            inset
                            :label="Swtcompl == true ? 'Si' : 'No'"
                            :disabled="!canEdit"
                            v-model="Swtcompl"
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-container v-if="Swtinsu" class="mt-n12">
                    <receta-product :canEdit="canEdit" @Receta="Receta" :SupplieId="SupplieId" :productBom="productBom"/>
                  </v-container>
                </v-container>
              </v-flex>
            </v-layout>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <template v-if="e1 == 1">
          <v-btn outlined color="blue darken-3" @click="ValidForm()">Siguiente</v-btn>
        </template>
        <template v-else-if="e1 == 2">
          <v-btn outlined color="blue darken-3" @click="e1 = 1">Volver atras</v-btn>
          <!--  <v-btn @click="Cerrar()" color="red accent-4" class="font-weight-medium">Cerrar</v-btn> -->
          <v-btn v-if="canEdit" color="blue accent-4" class="font-weight-medium" @click="GuardarDatos()">Guardar</v-btn>
        </template>
      </v-card-actions>

      <v-snackbar v-model="snackbar" :color="color" top multi-line :timeout="timeout">
        {{ text }}
        <v-spacer></v-spacer>
        <v-icon color="white" size="25">mdi-alert</v-icon>
      </v-snackbar>

      <modal-categoria :canEdit="canEdit" :dialog="dialog2" @close="close" @Guardar="Guardar"></modal-categoria>
      <modal-unidad :canEdit="canEdit" :dialog="dialog3" @close="close2" @Guardar="Guardar2"></modal-unidad>
      <modal-impuesto :canEdit="canEdit" :dialog="dialog4" @close="close3" @Guardar="Guardar3"></modal-impuesto>
      <add-tags :canEdit="canEdit" :dialog="addTag" @Close="addTag = false" :list_tags="Tags" @AddedTag="AddedTag"></add-tags>
      <code-search :canEdit="canEdit" :dialog="OpenSearch" @Close="OpenSearch = false" @SetCode="SetCode"></code-search>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, between, minValue } from "vuelidate/lib/validators";
import axios from "axios";
import _ from "lodash";
import { VMoney } from "v-money";

import "vue-loading-overlay/dist/vue-loading.css";
const minValueNumber = (value) => parseFloat(value) > 0.01;
export default {
  mixins: [validationMixin],
  validations: {
    NombreP: {
      required,
      maxLength: maxLength(150),
    },
    codigoP: { required },
    /*   codigoB: { required }, */
    NombreR: { required },
    NombreF: { required },
    Category: { required },
    Unidad: { required },
    /*  list_tags: { required }, */
    Precio: {
      required,
      minValue: minValueNumber,
    },
    ImpMonto: { required },
  },
  components: {
    ModalCategoria: () => import("./clasificacion"),
    ModalUnidad: () => import("./unidades"),
    ModalImpuesto: () => import("./impuestos"),
    RecetaProduct: () => import("../Receta"),
    Loading: () => import("vue-loading-overlay"),
    AddTags: () => import("./AddTag"),
    CodeSearch: () => import("./Products/Search"),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    edited: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Array,
      default: () => ({
        name: undefined,
      }),
    },
    canEdit:{
      type: Boolean,
      default: false,
    }
  },
  watch: {
    Precio(val, old) {
      if (this.$refs.Precio) {
        if (this.$refs.Precio.$el !== undefined) {
          this.$refs.Precio.$el.getElementsByTagName("input")[0].value =
            this.Precio;
        }
      }
    },
    Costo(val, old) {
      if (this.$refs.Costo) {
        if (this.$refs.Costo.$el !== undefined) {
          this.$refs.Costo.$el.getElementsByTagName("input")[0].value =
            this.Costo;
        }
      }
    },
    NombreP(val) {
      let remText = val.replace(/ /g, "");
      if (remText.length > 0) {
        this.detaNames = true;
      } else {
        this.detaNames = false;
      }
      this.NombreF = val;
    },
    dialog(val) {
      if (!val) {
        this.$v.$reset();
        this.Precio = 0;
        this.Costo = 0;
        this.e1 = 1;
        this.codigoP = "";
        this.codigoB = "";
        this.NombreP = "";
        this.NombreR = "";
        this.NombreF = "";
        this.Category = "";
        this.SubCategoria = null;
        this.Proveedor = null;
        this.Unidad = "";
        this.list_tags = [];
        this.recetaProducto = [];
        this.ImpMonto = [];
        this.Swtinvt = false;
        this.Swtprod = false;
        this.Swtinsu = false;
        this.Swtcompl = false;
        this.codeSat = "";
        this.PrecioFormat = 0;
        this.CostoFormat = 0;
      } else {
        if (this.edited) {
          this.codeSat = this.editedItem[0].satCode;
          this.codigoP = this.editedItem[0].code;
          this.codigoB = this.editedItem[0].barCode;
          this.NombreP = this.editedItem[0].name;
          this.NombreR = this.editedItem[0].shortName;
          this.NombreF = this.editedItem[0].invoiceName;
          this.Category = this.editedItem[0].category.id;
          this.SubCategoria = this.editedItem[0].subCategory !== null ? this.editedItem[0].subCategory.id : null;
          this.Proveedor = this.editedItem[0].provider !== null ? this.editedItem[0].provider.id : null;
          this.Unidad = this.editedItem[0].unit.id; //9;
          this.Swtinvt = this.editedItem[0].inventoryable;
          this.Swtprod = this.editedItem[0].produced;
          this.Swtinsu = this.editedItem[0].requiresSupplies;
          this.Swtcompl = this.editedItem[0].complement;
          this.list_tags = this.editedItem[0].productTags;
          this.Precio = parseFloat(this.editedItem[0].price).toFixed(2);
          this.Costo = parseFloat(this.editedItem[0].cost).toFixed(2);
          this.productBom = this.editedItem[0].productBom;
          let values = this.editedItem[0];
          _.map(values.taxes, (o) => {
            let r = _.find(this.Impuestos, (q) => {
              return q.id == o.id;
            });
            if (r != undefined) {
              this.ImpMonto.push(r);
            }
          });
        }
      }
    },
    Category(val) {},
    SubCategoria(val) {},
    Proveedor(val) {},
    ImpMonto(val) {
      this.Total_Imp = 0;
      if (val != null) {
        if (val.length > 0) {
          val.forEach((element) => {
            this.Total_Imp += parseFloat(element.percent);
          });
        } else {
          this.Total_Imp = 0;
        }
      }
    },
    Swtinsu(val) {
      if (val == true) {
        this.showInsumos = true;
      } else if (val == false) {
        this.showInsumos = false;
      }
    },
  },
  created() {
    this.LoadCategories();
    this.LoadSubCategories();
    this.LoadProviders();
    this.LoadUnits();
    this.LoadTags();
    this.LoadTaxes();
  },
  computed: {
    SetToolTitle() {
      if (this.detaNames) return "Ocultar Otros Nombre de Producto";
      else return "Mostrar Otros Nombres de Producto";
    },
    GetIcon() {
      if (this.detaNames) return "mdi-menu-up";
      else return "mdi-menu-down";
    },
    NombrePErrors() {
      const errors = [];
      if (!this.$v.NombreP.$dirty) return errors;
      !this.$v.NombreP.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    codigoPErrors() {
      const errors = [];
      if (!this.$v.codigoP.$dirty) return errors;
      !this.$v.codigoP.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    NombreRErrors() {
      const errors = [];
      if (!this.$v.NombreR.$dirty) return errors;
      !this.$v.NombreR.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    NombreFErrors() {
      const errors = [];
      if (!this.$v.NombreF.$dirty) return errors;
      !this.$v.NombreF.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    CategoryErrors() {
      const errors = [];
      if (!this.$v.Category.$dirty) return errors;
      !this.$v.Category.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    UnidadErrors() {
      const errors = [];
      if (!this.$v.Unidad.$dirty) return errors;
      !this.$v.Unidad.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    PrecioErrors() {
      const errors = [];
      if (!this.$v.Precio.$dirty) return errors;
      !this.$v.Precio.required && errors.push(this.$t("errors.required"));
      !this.$v.Precio.minValue && errors.push(this.$t("errors.min_value"));
      return errors;
    },
    ImpMontoErrors() {
      const errors = [];
      if (!this.$v.ImpMonto.$dirty) return errors;
      !this.$v.ImpMonto.required && errors.push(this.$t("errors.required"));
      return errors;
    },
    setDisabled() {
      if (this.e1 == 2) {
        return false;
      } else {
        return true;
      }
    },
    Impuestos() {
      let v = this.ListImpuestos;
      let d = [];
      _.map(v, (o) => {
        d.push({
          id: o.id,
          name: o.name + " - " + o.percent * 100 + "%",
          percent: o.percent,
          alias: o.alias,
          satCode: o.satCode,
        });
      });
      return d;
    },
    title() {
      let title_ = "";
      if (this.edited) {
        title_ = "Actualizar producto";
      } else {
        title_ = "Nuevo producto";
      }
      return title_;
    },
    Mostrar: {
      get: function () {
        return this.dialog;
      },
    },
    set: function (val) {
      if (!val) {
        this.$emit("Close");
      }
    },
    getListProducts: {
      get() {
        return this.$store.state._Productos;
      },
      set() {},
    },
  },
  methods: {
    validateCode() {
      this.$v.codigoP.$touch();
      if (!this.$v.codigoP.$error) {
        const val = this.$v.codigoP.$model;
        const g = _.find(this.getListProducts, { code: val });
        if (g) {
          this.snackbar = true;
          this.color = "error";
          this.timeout = 2500;
          this.text = `El código ${val} ya ha sido registrado`;
          this.codigoP = "";
          this.$v.codigoP.$touch();
        }
      }
    },
    SetCode(val) {
      this.codeSat = val.code;
      this.OpenSearch = false;
    },
    AddedTag(val) {
      this.LoadTags();
      this.list_tags.push(val.Tag);
    },
    remove(item) {
      this.list_tags.splice(this.list_tags.indexOf(item), 1);
      this.list_tags = [...this.list_tags];
    },
    ValidForm() {
      if(this.canEdit){
        this.$v.$touch();
        if (
          this.$v.NombreP.required &&
          this.$v.codigoP.required &&
          this.$v.NombreR.required &&
          this.$v.NombreF.required &&
          this.$v.Category.required &&
          this.$v.Unidad.required &&
          this.$v.Precio.required &&
          this.$v.Precio.minValue &&
          this.$v.ImpMonto.required
        ) {
          this.e1 = 2;
        } else {
          this.ShowBar({
            snackbar: true,
            timeout: 4000,
            color: "error",
            text: "Verifique los campos en Rojo.",
          });
        }
      }else{
        this.e1 = 2;
      }
    },
    keyhander: function (event) {
      if (event.keyCode === 32) {
        event.preventDefault();
      }
    },
    Receta(val) {
      this.recetaProducto = val;
    },
    sumVal(val) {
      let num1 = val;
      let num2 = parseFloat(num1) + parseFloat(val);
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    SetCoin(item) {
      return "$ " + this.formatNumber(parseFloat(item).toFixed(2));
    },
    setMonto(percent, satCode) {
      let precioP = 0;
      let precioC = 0;
      precioP = this.Precio;
      precioC = this.Costo;
      this.PrecioFormat = parseFloat(precioP.replace(/[,]/g, "")).toFixed(2);
      this.CostoFormat = parseFloat(precioC.replace(/[,]/g, "")).toFixed(2);

      let PrecioCosto = parseFloat(Number(this.PrecioFormat) / Number(1 + this.Total_Imp)).toFixed(3);
      if (satCode === "002") {
        return this.formatNumber(parseFloat(PrecioCosto * percent).toFixed(2));
      } else if (satCode === "003") {
        return this.formatNumber(parseFloat(PrecioCosto * percent).toFixed(2));
      } else if (satCode == "001") {
        return this.formatNumber(parseFloat(PrecioCosto * percent).toFixed(2));
      }
    },
    async LoadCategories() {
      const categories = await axios.get("/api/Catalogs/Category", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.Categoria = categories.data;
    },
    async LoadSubCategories() {
      const subcategories = await axios.get("/api/Catalogs/SubCategory", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.SubCategorias = subcategories.data;
    },
    async LoadProviders() {
      const result = await axios.get("/api/Provider", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.Proveedores = result.data;
    },
    async LoadTaxes() {
      const result = await axios.get("/api/Catalogs/Tax", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.ListImpuestos = result.data;
    },
    async LoadTags() {
      this.Tags = [];
      const result = await axios.get("/api/Catalogs/Tag", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.Tags = result.data;
    },
    async LoadUnits() {
      const result = await axios.get("/api/Catalogs/Unit", { headers: { bussinessId: this.$store.state._bussinessAccountId } });
      this.Unidades = result.data;
    },
    GuardarDatos() {
      this.$v.$touch();
      if (
        this.$v.NombreP.required &&
        this.$v.codigoP.required &&
        this.$v.NombreR.required &&
        this.$v.NombreF.required &&
        this.$v.Category.required &&
        this.$v.Unidad.required &&
        this.$v.Precio.required &&
        this.$v.ImpMonto.required
      ) {
        let productTags = [],
        supplies = [],
        Taxes = [];
        this.list_tags.forEach((element, index) => {
          productTags.push(element.id);
        });
        this.recetaProducto.forEach((element) => {
          supplies.push({
            supplieId: element.id,
            quantity: parseFloat(element.cantidad),
          });
        });
        this.ImpMonto.forEach((element) => {
          Taxes.push(element.id);
        });
        const precioFormated = this.Precio.replace(/[,]/g, "");
        const costoFormated = this.Costo.replace(/[,]/g, "");
        this.$emit("Guardar", {
          codeSat: this.codeSat,
          code: this.codigoP,
          barCode: this.codigoB,
          name: this.NombreP,
          shortName: this.NombreR,
          invoiceName: this.NombreF,
          categoryId: this.Category,
          subcategoryId: this.SubCategoria,
          providerId: this.Proveedor,
          price: precioFormated,
          cost: costoFormated,
          unitId: this.Unidad,
          productTags: productTags,
          taxes: Taxes,
          inventoryable: this.Swtinvt,
          produced: this.Swtprod,
          requiresSupplies: this.Swtinsu,
          supplies: supplies,
          complement: this.Swtcompl,
        });
      } else {
        this.ShowBar({
          snackbar: true,
          timeout: 4000,
          color: "error",
          text: "Verifique los campos en Rojo.",
        });
      }
    },
    SetVal(val) {
      if (val == 1) {
        if (this.Swtprod == true) {
          this.Swtinsu = true;
          this.readOnlyinsu = true;
        } else {
          this.Swtinsu = false;
          this.readOnlyinsu = false;
        }
      } else if (val == 2) {
        if (this.Swtinsu == true) {
          this.Swtprod = true;
          this.readonlyProd = true;
        } else {
          this.Swtprod = false;
          this.readonlyProd = false;
        }
      }
    },
    close3() {
      this.dialog4 = false;
    },
    Guardar3(values) {
      const body = {
        name: values.name,
        alias: values.alias,
        percent: values.percent,
        satCode: values.satCode,
      };
      axios.post("/api/Catalogs/Tax", body, { headers: { bussinessId: this.$store.state._bussinessAccountId } })
      .then((result) => {
        return result.data;
      })
      .then((data) => {
        this.ShowBar({
          snackbar: true,
          timeout: 2000,
          color: "#388E3C",
          text: "Registro exitoso.",
        });
        this.LoadTaxes();
        this.dialog4 = false;
      })
      .catch((err) => {
        Swal.fire({
          title: "Error al registrar",
          text: "Ooops Ocurrio un error al registrar la información",
          type: "error",
        });
      });
    },
    close2() {
      this.dialog3 = false;
    },
    // Guardar las Unidades
    Guardar2(values) {
      const body = {
        name: values.name,
        alias: values.alias,
        satCode: values.satCode,
      }
      axios.post("/api/Catalogs/Unit", body, { headers: { bussinessId: this.$store.state._bussinessAccountId } })
      .then((result) => {
        return result.data;
      }).then((data) => {
        this.ShowBar({
          snackbar: true,
          timeout: 2000,
          color: "#388E3C",
          text: "Registro exitoso.",
        });
        this.LoadUnits();
        this.dialog3 = false;
      })
      .catch((err) => {
        console.log(err);
      });
    },
    close() {
      this.dialog2 = false;
    },
    ShowBar(values) {
      this.snackbar = values.snackbar;
      this.timeout = values.timeout;
      this.color = values.color;
      this.text = values.text;
    },
    // Guardar las Clasificaciones
    Guardar(values) {
      const body = {
        name: values.nombre,
        alias: values.alias,
        color: values.color,
      }
      axios.post("/api/Catalogs/Category", body, { headers: { bussinessId: this.$store.state._bussinessAccountId } })
      .then((result) => {
        return result.data;
      })
      .then((data) => {
        this.ShowBar({
          snackbar: true,
          timeout: 2000,
          color: "#388E3C",
          text: "Registro exitoso.",
        });
        this.LoadCategories();
        this.dialog2 = false;
      })
      .catch((err) => {});
    },
    Add(val) {
      if (val == 1) {
        this.dialog2 = true;
      } else if (val == 2) {
        this.dialog3 = true;
      } else if (val == 3) {
        this.dialog4 = true;
      } else if (val == 3) {
        this.dialog5 = true;
      }
    },
    Cerrar() {
      this.$emit("Close");
    },
  },
  data() {
    return {
      OpenSearch: false,
      codeSat: null,
      PrecioFormat: 0,
      CostoFormat: 0,
      Unidades: [],
      Categoria: [],
      SubCategorias: [],
      Proveedores: [],
      Tags: [],
      SupplieId: 0,
      MyTags: [],
      ListImpuestos: [],
      text: null,
      timeout: null,
      snackbar: false,
      EditedItem: [],
      addTag: false,
      productBom: [],
      money: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false,
      },
      moneyCosto: {
        decimal: ".",
        thousands: ",",
        precision: 2,
        masked: false
      },
      //loading: false,
      detaNames: false,
      panelIndex: -9,
      list_tags: [],
      showInsumos: false,
      percent: null,
      imptVal: 0,
      dialog2: false,
      dialog3: false,
      dialog4: false,

      Category: null,
      SubCategoria: null,
      Proveedor: null,
      e1: 1,
      codigoP: null,
      codigoB: null,
      NombreP: null,
      NombreR: null,
      NombreF: null,
      color: null,
      Precio: 0,
      Costo: 0,
      Unidad: null,
      Etiquetas: null,
      ImpMonto: [],
      ImpClv: null,

      search: null,

      Swtinvt: false,
      Swtprod: false,
      Swtinsu: false,
      Swtcompl: false,
      readOnlyinsu: false,
      readonlyProd: false,
      imp_trasladados: 0,

      recetaProducto: [],

      Total_Imp: "",

      headers: [
        {
          text: "Nombre",
          value: "name",
        },
        {
          text: "Porcentaje",
          value: "percent",
        },
      ],
      catImpuestos: [],
    };
  },
  directives: {
    money: VMoney,
  },
};
</script>
